<template>
  <div class="col-sm-12">
    <div class="row">
      <div class="col-sm-2 text-center">
        <span class="material-icons-outlined info-icon"> info </span>
      </div>
      <div class="col-sm-10">
        <h4 class="text-primary">Course Materials Selection Pending</h4>
        <div class="">
          <p>We have not yet received information regarding this course.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "SelectionPending",
  
}

</script>

<style scoped>
.info-icon {
  font-size: 88px;
  color: orange;
}
</style>
